import React from "react";
import { ElfsightWidget } from "react-elfsight-widget";
import s from "./InstagramEmbed.module.scss";
import titleImage from "../../assets/images/titleImage.png";

const InstagramEmbed = () => {
    return (
        <div className={"row  mt-5 mb-3"}>
            <div className={"col-12"}>
                <div className={s.titleWrrapper}>
                    <img className={s.titleImage} src={titleImage}/>
                    <h2 className={s.primaryTitle}>インスタグラムで現地情報発信中！</h2>
                    <h3 className={s.secondaryTitle}>Instagram</h3>

                </div>
            </div>
            <div className={"col-12"}>
                <div className={s.root}>
                    <ElfsightWidget
                        widgetId="db956b6b-42fb-4ab6-912d-324f32ae8b67"
                        lazy // enables lazy loading (recommended)
                    />
                </div>
            </div>
        </div>

    );
};

export default InstagramEmbed;